import BaseObject from "@shared/BaseObject.js";
import DataFilter from "@/core/js/backend/filters/DataFilter.js";
import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {getPlannedSessionServiceItems} from "@shared/Journal/TlswSessionPlanMismatchHelper";

const SESSION_COUNT_PAGE_SIZE = 200

export default class TlswSessionPlanCounterManager extends BaseObject {
	dataManager = null
	fetchParamsExtra = []

	constructor(options = {}) {
		super(options)
		this.applyOptions(options)
	}

	async syncClientProfileSessionCounts(clientId, {clientProfile = null, shouldPersist = true, updateOptions = {}} = {}) {
		let profile = clientProfile || await this.dataManager.getClientProfile(...this.fetchParamsExtra, clientId)
		let quoteItem = profile?.getCommissionDetails?.()?.getQuoteItem?.()
		let groups = getPlannedSessionServiceItems(quoteItem)
		let sessionCountMap = Object.fromEntries(groups.map(group => [group.id, 0]))
		let totalFilter = new DataFilter(SESSION_COUNT_PAGE_SIZE).where("clientId", "==", clientId)
			.where("type", "==", JournalEntryType.SESSION)
		let pager = await this.dataManager.getJournalEntryListPager(...this.fetchParamsExtra, totalFilter)
		let totalCount = 0
		while (pager.hasMore) {
			let sessions = await pager.next()
			for (let session of sessions) {
				totalCount++
				if (Object.prototype.hasOwnProperty.call(sessionCountMap, session.sourceServiceId)) {
					sessionCountMap[session.sourceServiceId]++
				}
			}
		}
		profile?.getCommissionDetails?.()?.setSessionCountBySourceServiceIdMap?.(sessionCountMap)
		if (profile?.getCommissionDetails?.()?.progressInfo) {
			profile.getCommissionDetails().progressInfo.totalSessionsCount = totalCount
		}
		if (shouldPersist) {
			await this.dataManager.updateClientProfile(...this.fetchParamsExtra, {
				id: clientId,
				"commissionDetails.progressInfo.sessionCountBySourceServiceId": sessionCountMap,
				"commissionDetails.progressInfo.totalSessionsCount": totalCount,
			}, updateOptions)
		}
		return sessionCountMap
	}
}
